<template>
    <div class="d-flex justify-content-center pt-3 flex-grow-1">
        <span v-if="isLoading" class="spinner-border spinner-border-md"></span>
        <form id="register-form" v-else class="w-100">
            <ul id="progressbar">
                <li
                    class="completed active"
                    :class="{
                        active: currentStep >= 1,
                        completed: currentStep > 1,
                    }"
                >
                    Dados de Acesso
                </li>
                <li
                    :class="{
                        active: currentStep >= 2,
                        completed: currentStep > 2,
                    }"
                >
                    Dados da Empresa
                </li>
                <li
                    :class="{
                        active: currentStep >= 3,
                        completed: currentStep > 3,
                    }"
                >
                    Endereço da Empresa
                </li>
            </ul>
            <fieldset v-if="currentStep === 1">
                <h2 class="fs-title">Dados de Acesso</h2>
                <div class="form-group">
                    <label
                        >Nome do Usuário Principal
                        <span class="text-danger">*</span></label
                    >
                    <input
                        type="text"
                        class="name form-control"
                        :class="{ 'is-invalid': errors.name }"
                        name="name"
                        placeholder="João de Souza"
                        autocomplete="off"
                        v-model="userData.name"
                        required=""
                    />
                    <div v-if="errors.name" class="invalid-feedback">
                        <strong>{{ errors.name.join(", ") }}</strong>
                    </div>
                </div>
                <div class="form-group">
                    <label>E-mail <span class="text-danger">*</span></label>
                    <input
                        type="email"
                        readonly
                        class="user-email form-control"
                        :class="{ 'is-invalid': errors.email }"
                        placeholder="email@email.com"
                        autocomplete="off"
                        v-model="userData.email"
                        required=""
                    />
                    <div v-if="errors.email" class="invalid-feedback">
                        <strong>{{ errors.email.join(", ") }}</strong>
                    </div>
                </div>
                <button
                    type="button"
                    class="btn btn-lg btn-block btn-success next action-button btn-step-1 text-uppercase"
                    @click="handleNext"
                    :disabled="firstError"
                >
                    Próximo
                </button>
            </fieldset>
            <fieldset v-if="currentStep === 2">
                <h2 class="fs-title">Dados da Empresa</h2>
                <div class="form-group">
                    <label>CNPJ <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="cnpj form-control"
                        :class="{ 'is-invalid': errors.user_cnpj }"
                        name="cnpj"
                        v-model="userData.user_cnpj"
                        placeholder="00.000.000/0000-00"
                        @change="findCnpj"
                        v-mask="'##.###.###/####-##'"
                        required=""
                    />
                    <div v-if="errors.user_cnpj" class="invalid-feedback">
                        <strong>{{ errors.user_cnpj.join(", ") }}</strong>
                    </div>
                </div>
                <div class="form-group">
                    <label>Nome Fantasia</label>
                    <input
                        type="text"
                        class="nome_fantasia form-control"
                        name="user_nome_fantasia"
                        placeholder="Nome Fantasia"
                        v-model="userData.user_nome_fantasia"
                    />
                    <div
                        v-if="errors.user_nome_fantasia"
                        class="invalid-feedback"
                    >
                        <strong>{{
                            errors.user_nome_fantasia.join(", ")
                        }}</strong>
                    </div>
                </div>
                <div class="form-group">
                    <label
                        >Razão Social <span class="text-danger">*</span></label
                    >
                    <input
                        type="text"
                        class="razao_social form-control"
                        name="user_razao_social"
                        placeholder="Razão Social"
                        required=""
                        :class="{ 'is-invalid': errors.user_razao_social }"
                        v-model="userData.user_razao_social"
                    />
                    <div
                        v-if="errors.user_razao_social"
                        class="invalid-feedback"
                    >
                        <strong>{{
                            errors.user_razao_social.join(", ")
                        }}</strong>
                    </div>
                </div>
                <div class="form-group">
                    <label>Telefone</label>
                    <input
                        type="text"
                        class="telefone_1 tel form-control"
                        name="user_telefone"
                        placeholder="(00)0000-0000"
                        v-model="userData.user_telefone"
                    />
                    <div v-if="errors.user_telefone" class="invalid-feedback">
                        <strong>{{ errors.user_telefone.join(", ") }}</strong>
                    </div>
                </div>
                <div class="form-group">
                    <label>Celular <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        name="user_celular"
                        class="cel form-control"
                        placeholder="(00)00000-0000"
                        v-model="userData.user_celular"
                    />
                    <div v-if="errors.user_celular" class="invalid-feedback">
                        <strong>{{ errors.user_celular.join(", ") }}</strong>
                    </div>
                </div>
                <button
                    type="button"
                    name="previous"
                    class="btn btn-lg previous action-button-previous text-uppercase"
                    @click="handlePrevious"
                >
                    Voltar
                </button>
                <button
                    type="button"
                    class="btn btn-lg btn-success next action-button text-uppercase"
                    @click="handleNext"
                    :disabled="secondError"
                >
                    Próximo
                </button>
            </fieldset>
            <fieldset v-if="currentStep === 3">
                <h2 class="fs-title">Endereço da Empresa</h2>
                <div class="form-group">
                    <label>CEP <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        name="cep"
                        class="form-control cep getCep"
                        required=""
                        v-mask="'#####-###'"
                        v-model="userData.user_cep"
                        @change="findCep"
                    />
                    <div v-if="errors.user_cep" class="invalid-feedback">
                        <strong>{{ errors.user_cep.join(", ") }}</strong>
                    </div>
                </div>
                <div class="form-group">
                    <label>Estado <span class="text-danger">*</span></label>
                    <e-select
                        route="estados"
                        name="uf"
                        v-model="userData.user_uf"
                        :class="{ 'is-invalid': errors.user_uf }"
                    />
                    <div v-if="errors.user_uf" class="invalid-feedback">
                        <strong>{{ errors.user_uf.join(", ") }}</strong>
                    </div>
                </div>
                <div class="form-group">
                    <label>Município <span class="text-danger">*</span></label>
                    <model-select
                        ref="select"
                        name="user_municipio"
                        :options="options"
                        v-model="userData.user_municipio"
                        placeholder="Selecione..."
                        :class="{ 'is-invalid': errors.user_municipio }"
                    />
                    <div v-if="errors.user_municipio" class="invalid-feedback">
                        <strong>{{ errors.user_municipio.join(", ") }}</strong>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-10">
                        <label
                            >Logradouro
                            <span class="text-danger">*</span></label
                        >
                        <input
                            type="text"
                            name="logradouro"
                            class="form-control logradouro"
                            placeholder="Logradouro"
                            required=""
                            v-model="userData.user_logradouro"
                            :class="{ 'is-invalid': errors.user_logradouro }"
                        />
                        <div
                            v-if="errors.user_logradouro"
                            class="invalid-feedback"
                        >
                            <strong>{{
                                errors.user_logradouro.join(", ")
                            }}</strong>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <label>Nº <span class="text-danger">*</span></label>
                        <input
                            type="text"
                            name="numero"
                            class="form-control numero"
                            required=""
                            v-model="userData.user_numero"
                            :class="{ 'is-invalid': errors.user_numero }"
                        />
                        <div v-if="errors.user_numero" class="invalid-feedback">
                            <strong>{{ errors.user_numero.join(", ") }}</strong>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Complemento</label>
                    <input
                        type="text"
                        name="complemento"
                        class="form-control complemento"
                        placeholder="Complemento"
                        v-model="userData.user_complemento"
                        :class="{ 'is-invalid': errors.user_complemento }"
                    />
                    <div
                        v-if="errors.user_complemento"
                        class="invalid-feedback"
                    >
                        <strong>{{
                            errors.user_complemento.join(", ")
                        }}</strong>
                    </div>
                </div>

                <div class="form-group">
                    <label>Bairro <span class="text-danger">*</span></label>
                    <input
                        type="text"
                        name="bairro"
                        class="form-control bairro"
                        placeholder="Bairro"
                        required=""
                        v-model="userData.user_bairro"
                        :class="{ 'is-invalid': errors.user_bairro }"
                    />
                    <div v-if="errors.user_bairro" class="invalid-feedback">
                        <strong>{{ errors.user_bairro.join(", ") }}</strong>
                    </div>
                </div>
                <button
                    type="button"
                    name="previous"
                    class="btn btn-lg previous action-button-previous text-uppercase"
                    @click="handlePrevious"
                >
                    Voltar
                </button>
                <button
                    type="button"
                    class="btn btn-lg btn-success next action-button btn-step-1 text-uppercase"
                    @click="submit"
                    :disabled="thirdError || isSubmitting"
                >
                    <span v-if="!isSubmitting">Salvar</span>
                    <span v-else>Salvando...</span>
                </button>
            </fieldset>
        </form>
    </div>
</template>
<script>
import Estados from "../sistema/Estados.vue";
import { z } from "zod";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
import { TheMask } from "vue-the-mask";

const firstSchema = z.object({
    name: z
        .string({
            message: "Informe o nome completo",
        })
        .trim()
        .refine((val) => val.split(" ").length > 1, {
            message: "Informe seu nome completo",
        }),
    email: z.string().email({ message: "Informe um e-mail válido" }),
});

const secondSchema = z.object({
    user_cnpj: z.string().min(14, { message: "CNPJ inválido" }),
    user_nome_fantasia: z.string().optional(),
    user_razao_social: z.string().min(3, { message: "Razão Social inválida" }),
    user_telefone: z.string().optional(),
    user_celular: z.string().min(10, {
        message: "O número de celular deve ter pelo menos 10 dígitos",
    }),
});

const thirdSchema = z.object({
    user_cep: z.string().min(8, { message: "CEP inválido" }),
    user_uf: z.string().min(2, { message: "UF inválida" }),
    user_municipio: z.string().min(2, { message: "Município inválido" }),
    user_logradouro: z.string().min(3, { message: "Logradouro inválido" }),
    user_numero: z.string().min(1, { message: "Número inválido" }),
    user_complemento: z.string().optional(),
    user_bairro: z.string().min(3, { message: "Bairro inválido" }),
});

export default {
    components: { Estados, ModelSelect, TheMask },
    async beforeMount() {
        this.isLoading = true;
        try {
            const { data } = await this.$api.get("/v2/users/me");

            const keys = Object.keys(this.userData);
            keys.forEach((key) => {
                if (key == "user_celular") {
                    this.userData.user_celular = data[key] || data.user_cell;
                    return;
                }
                if (data[key]) {
                    this.userData[key] = data[key];
                }
            });
            this.checkRegister();
        } catch (e) {
            this.$swal.fire({
                title: "Erro",
                text: "Não foi possível carregar os dados do usuário.",
                icon: "error",
                confirmButtonText: "Confirmar",
            });
        } finally {
            this.isLoading = false;
        }
    },

    watch: {
        "userData.user_uf": {
            handler: "loadMunicipios",
            immediate: true,
        },
        "userData.user_cep": {
            handler: "findCep",
            immediate: true,
        },
        userData: {
            async handler(data, oldData) {
                if (this.shouldRevalidate) {
                    if (this.currentStep == 1) {
                        const result = await firstSchema.safeParseAsync(
                            this.userData
                        );
                        if (!result.success) {
                            this.firstError = true;
                            this.shouldRevalidate = true;
                            this.errors = result.error.flatten().fieldErrors;
                            return;
                        }
                        this.firstError = false;
                        this.errors = {};
                        this.shouldRevalidate = false;
                    }

                    if (this.currentStep == 2) {
                        const result = await secondSchema.safeParseAsync(
                            this.userData
                        );
                        if (!result.success) {
                            this.secondError = true;
                            this.shouldRevalidate = true;
                            this.errors = result.error.flatten().fieldErrors;
                            return;
                        }
                        this.secondError = false;
                        this.errors = {};
                        this.shouldRevalidate = false;
                    }

                    if (this.currentStep == 3) {
                        const result = await thirdSchema.safeParseAsync(
                            this.userData
                        );
                        if (!result.success) {
                            this.thirdError = true;
                            this.shouldRevalidate = true;
                            this.errors = result.error.flatten().fieldErrors;
                            return;
                        }
                        this.thirdError = false;
                        this.errors = {};
                        this.shouldRevalidate = false;
                    }
                    return;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        checkRegister() {
            if (!this.userData.user_cnpj && !this.userData.user_uf) {
                this.$swal.fire({
                    title: "Atenção",
                    text: "Complete seu cadastro para continuar.",
                    icon: "warning",
                    confirmButtonText: "Confirmar",
                });
            }
        },
        async findCep() {
            const cep = this.userData.user_cep.replace(/\D/g, "");

            if (cep.length !== 8) {
                return;
            }
            function getNonEmptyValue(newValue, currentValue) {
                return newValue && newValue.trim() !== ""
                    ? newValue.trim()
                    : currentValue.trim();
            }
            try {
                const result = await this.$api.get(`v2/cep/find`, {
                    params: {
                        cep,
                    },
                });

                if (result.data) {
                    this.userData.user_uf = getNonEmptyValue(
                        result.data.uf,
                        this.userData.user_uf
                    );
                    this.userData.user_municipio = getNonEmptyValue(
                        result.data.localidade,
                        this.userData.user_municipio
                    );
                    this.userData.user_bairro = getNonEmptyValue(
                        result.data.bairro,
                        this.userData.user_bairro
                    );
                    this.userData.user_logradouro = getNonEmptyValue(
                        result.data.logradouro,
                        this.userData.user_logradouro
                    );
                    this.userData.user_complemento = getNonEmptyValue(
                        result.data.complemento,
                        this.userData.user_complemento
                    );
                }
            } catch (e) {}
        },
        async loadMunicipios() {
            const uf = this.userData.user_uf;
            if (!uf) {
                return;
            }
            const result = await this.$api.get(`municipios/ufstring/${uf}`);

            this.options = result.data;
        },

        async findCnpj() {
            const cnpj = this.userData.user_cnpj.replace(/\D/g, "");

            if (cnpj.length !== 14) {
                return;
            }
            try {
                await this.$api.get(
                    `v2/users/check-cnpj?user_cnpj=${this.userData.user_cnpj}`
                );
                this.errors.user_cnpj = "";
            } catch (e) {
                if (e.response.status == 409) {
                    this.errors.user_cnpj = [
                        `O CNPJ '${this.userData.user_cnpj}' já está cadastrado`,
                    ];
                    this.$swal.fire({
                        title: "Erro",
                        text: "CNPJ já cadastrado",
                        icon: "error",
                        confirmButtonText: "Confirmar",
                    });
                    return;
                }
                this.$swal.fire({
                    title: "Erro",
                    text: "Não foi possível verificar o CNPJ.",
                    icon: "error",
                    confirmButtonText: "Confirmar",
                });
                return;
            }
            try {
                const {
                    data: { result, status },
                } = await this.$api.get(`parceiro/receitaws/${cnpj}`);

                if (status != "200") {
                    this.errors.user_cnpj = ["CNPJ inválido"];
                    this.$swal.fire({
                        title: "Erro",
                        text: "CNPJ inválido",
                        icon: "error",
                        confirmButtonText: "Confirmar",
                    });
                    return;
                }
                this.errors.user_cnpj = "";
                const keys = Object.keys(result);
                keys.forEach((key) => {
                    const formKey = `user_${key}`;
                    if (!Object.keys(this.userData).includes(formKey)) {
                        return;
                    }
                    this.userData[formKey] = result[key];
                });
            } catch (e) {
                this.$swal.fire({
                    title: "Erro",
                    text: "Não foi possível carregar os dados do CNPJ.",
                    icon: "error",
                    confirmButtonText: "Confirmar",
                });
            }
        },
        async submit() {
            this.isSubmitting = true;
            try {
                const result = await thirdSchema.safeParseAsync(this.userData);
                if (!result.success) {
                    this.thirdError = true;
                    this.shouldRevalidate = true;
                    this.errors = result.error.flatten().fieldErrors;
                    return;
                }
                const response = await this.$api.put(
                    "/v2/users",
                    this.userData
                );

                if (response.status == 200) {
                    this.$swal
                        .fire({
                            title: "Sucesso",
                            text: "Dados atualizados com sucesso.",
                            icon: "success",
                            confirmButtonText: "Confirmar",
                        })
                        .then(() => {
                            window.location.href = "/";
                        });
                }
                this.isSubmitting = false;
                return;
            } catch (e) {
                if (e.response.status == 422) {
                    this.errors = e.response.data.errors;
                }

                this.$swal.fire({
                    title: "Erro",
                    text: "Não foi Atualizar os dados.",
                    icon: "error",
                    confirmButtonText: "Confirmar",
                });
            } finally {
                this.isSubmitting = false;
            }
        },
        async handleNext() {
            if (this.currentStep === 1) {
                const result = await firstSchema.safeParseAsync(this.userData);
                if (!result.success) {
                    this.firstError = true;
                    this.shouldRevalidate = true;
                    this.errors = result.error.flatten().fieldErrors;
                    return;
                }
                this.firstError = false;
                this.shouldRevalidate = false;
                this.currentStep++;
                return;
            }

            if (this.currentStep === 2) {
                const result = await secondSchema.safeParseAsync(this.userData);
                if (!result.success) {
                    this.secondError = true;
                    this.shouldRevalidate = true;
                    this.errors = result.error.flatten().fieldErrors;
                    return;
                }
                this.secondError = false;
                this.shouldRevalidate = false;
                this.currentStep++;
                return;
            }

            if (this.currentStep === 3) {
                this.submit();
            }
        },
        handlePrevious() {
            this.currentStep--;
        },
    },
    data() {
        return {
            options: [{ text: "Selecione um estado...", value: null }],
            shouldRevalidate: false,
            firstError: false,
            secondError: false,
            thirdError: false,
            currentStep: 1,
            isLoading: true,
            isSubmitting: false,
            errors: {},
            userData: {
                name: "",
                email: "",
                user_cnpj: "",
                user_nome_fantasia: "",
                user_razao_social: "",
                user_telefone: "",
                user_celular: "",
                user_cep: "",
                user_uf: "",
                user_municipio: "",
                user_logradouro: "",
                user_numero: "",
                user_complemento: "",
                user_bairro: "",
            },
        };
    },
};
</script>
<style>
.next {
    font-weight: 600;
}

/*form styles*/
#register-form {
    /*                text-align: center;*/
    position: relative;
    margin-top: 20px;
}

#register-form fieldset {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.4);
    padding: 20px 30px;
    box-sizing: border-box;
    width: 80%;
    margin: 0 10%;

    /*stacking fieldsets above each other*/
    position: relative;
}

/*Hide all except first fieldset*/
#register-form fieldset:not(:first-of-type) {
    display: none;
}

#register-form input:focus,
#register-form textarea:focus {
    -moz-box-shadow: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: 1px solid #ee0979;
    outline-width: 0;
    transition: All 0.5s ease-in;
    -webkit-transition: All 0.5s ease-in;
    -moz-transition: All 0.5s ease-in;
    -o-transition: All 0.5s ease-in;
}

/*buttons*/

#register-form .action-button:hover,
#register-form .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #218838;
}

#register-form .action-button-previous {
    width: 100px;
    background: #c5c5f1;
    font-weight: bold;
    color: white;
    border: 0 none;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#register-form .action-button-previous:hover,
#register-form .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #c5c5f1;
}

/*headings*/
.fs-title {
    font-size: 18px;
    text-transform: uppercase;
    color: #2c3e50;
    margin-bottom: 10px;
    letter-spacing: 2px;
    font-weight: bold;
}

.fs-subtitle {
    font-weight: normal;
    font-size: 13px;
    color: #666;
    margin-bottom: 20px;
}
/* progressbar */
#progressbar {
    margin-bottom: 20px;
    overflow: hidden;
    counter-reset: step;
    position: relative;
}

#progressbar li {
    list-style-type: none;
    color: #666;
    text-transform: uppercase;
    text-align: center;
    font-size: 9px;
    width: 33.33%;
    float: left;
    position: relative;
    letter-spacing: 1px;
    z-index: 1;
}

#progressbar li:before {
    position: relative;
    content: counter(step);
    counter-increment: step;
    width: 24px;
    height: 24px;
    line-height: 24px;
    display: block;
    font-size: 12px;
    color: #333;
    background: white;
    font-weight: bold;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    z-index: 2;
}

/* progressbar connectors */
#progressbar li:after {
    /* content: "";*/
    width: 100%;
    height: 2px;
    background: white;
    position: absolute;
    left: 0;
    transform: translateX(-50%);
    top: 22%;
    z-index: 0;
}

#progressbar li:first-child:after {
    content: none;
}
#progressbar li.completed:before {
    background-color: #5ac727 !important;
}
#progressbar li.active:before,
#progressbar li.active:after {
    background: #e85326;
    color: white;
    z-index: 2;
}
</style>
